import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import mountainsBg from "../assets/images/mountains-bg.webp";
import { userLogin } from "../services/authService"; // Import your login service

export default function LoginComponent() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false); // To track loading state
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(""); // Reset error state before the API call

    if (email) {
      try {
        const response = await userLogin(email); // Call the API with the email
        if (response && response.success) {
          // If login is successful, navigate to the verification page
          localStorage.setItem("username", email);
          navigate("/verification");
        } else {
          // Handle unsuccessful login (you can check for a specific error message here)
          setError("Login failed. Please try again.");
        }
      } catch (error) {
        // Handle API errors
        setError("An error occurred. Please try again later.");
      } finally {
        setLoading(false); // Stop loading after the request
      }
    } else {
      setError("Please enter a valid email address.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-teal-300 via-teal-400 to-emerald-500 flex items-center justify-center p-4 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${mountainsBg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F977E]/90 via-[#0F977E]/40 to-[#03251F]/100"></div>
      </div>

      {/* Login Card */}
      <div className="w-full max-w-[650px] xxl:max-w-[500px] bg-white rounded-3xl shadow-2xl p-8 sm:p-16 relative z-10 bg-white/80">
        <div className="flex justify-center mb-8">
          <div className="text-center">
            <div className="flex items-center justify-center gap-2 mb-1">
              <img width="150" height="40" alt="CIEMS" src="/images/logo.png" />
            </div>
          </div>
        </div>

        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
            Log In Your Account
          </h2>
          <p className="text-gray-600 text-sm sm:text-base">
            Please fill your details to access your account.
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Email Address
            </label>
            <input
              id="email"
              type="email"
              placeholder="Enter Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full input-form-field bg-white h-[50px] xxl:h-[40px] px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition-all"
              required
            />
          </div>

          {/* Show error message if login failed */}
          {error && <div className="text-red-500 text-sm">{error}</div>}

          <button
            type="submit"
            className={`common-btn w-full ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading} // Disable the button while loading
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
